import React, { useEffect } from 'react'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { Link } from 'react-router-dom'

import Header from '../common/Header'
import SideMenu from '../common/SideMenu'

import Tr from './Tr';

import './Oripa.css'
import ImageModal from '../common/Modal/ImageModal'

import { useTranslation } from "react-i18next";

const Oripa = ({force}) => {
  const { t } = useTranslation();

  const {id} = useParams();
  const {shop} = useParams();

  const [cardSetting, changeCardSetting] = useState(true);

  const showCardSettingHandler = () => {
    changeCardSetting(true);
  }

  const hideCardSettingHandler = () => {
    changeCardSetting(false);
  }

  const deleteHandler = (e) => {
    e.preventDefault();
    if (window.confirm(t('oripa.confirm1'))) {
      let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
      if (xsrfToken) {
          xsrfToken = xsrfToken.split('=')[1]
      }
      let token = document.cookie.split('; ').find(row => row.startsWith('token'));
      if (token) {
          token = token.split('=')[1]
      }
      fetch(`${process.env.REACT_APP_API_URL}/api/package-delete/${id}`, {
        method: 'GET',
        headers: {
          'X-XSRF-TOKEN': xsrfToken,
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json'
        },
        credentials: 'include'
      })
      .then(res => res.json())
      .then(data => {
        if(!data.errors) {
          alert(t('oripa.deleted'));
          window.location.href = `/${shop}`;
        } else {
          alert(Object.values(data.errors)[0]);
        }
      })
      .catch(err => {
        console.log(err);
      });
    }
  }

  if (force) {
    let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
    if (xsrfToken) {
        xsrfToken = xsrfToken.split('=')[1]
    }
    let token = document.cookie.split('; ').find(row => row.startsWith('token'));
    if (token) {
      token = token.split('=')[1]
    }
    fetch(`${process.env.REACT_APP_API_URL}/api/status-change/${id}/force`, {
      method: 'GET',
      headers: {
        'X-XSRF-TOKEN': xsrfToken,
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json'
      },
      credentials: 'include'
    })
    .then(res => res.json())
    .then(data => {
      if(!data.errors) {
        alert(t('oripa.changed'));
        window.location.href = `/${shop}/oripa/${id}`;
      } else {
        alert(Object.values(data.errors)[0]);
      }
    })
    .catch(err => {
      console.log(err);
    });
  }

  const copyHandler = (e) => {
    e.preventDefault();
    if (window.confirm(t('oripa.confirm2'))) {
      let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
      if (xsrfToken) {
          xsrfToken = xsrfToken.split('=')[1]
      }
      let token = document.cookie.split('; ').find(row => row.startsWith('token'));
      if (token) {
          token = token.split('=')[1]
      }
      fetch(`${process.env.REACT_APP_API_URL}/api/package/copy/${id}`, {
        method: 'GET',
        headers: {
          'X-XSRF-TOKEN': xsrfToken,
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json'
        },
        credentials: 'include'
      })
      .then(res => res.json())
      .then(data => {
        if(!data.errors) {
          window.location.href = `/${shop}/oripa/${data.id}/edit`;
          
        } else {
          alert(Object.values(data.errors)[0]);
        }
      })
      .catch(err => {
        console.log(err);
      });
    }
  }
          

  const [totalRefundPoint, setTotalRefundPoint] = useState(0);
  const [totalNumber, setTotalNumber] = useState(0);

  const [packageTypeList, setPackageTypeList] = useState([]);
  const [packageInfo, setPackageInfo] = useState({
    packageId: '',
    packageType: '',
    packageName: '',
    packagePrice: '',
    packageNumber: '',
    packageStartAt: '',
    packageEndAt: '',
    packageImage: '',
    packageImageEn: '',
    packageImageJp: '',
  });

  const [cardNumber, setCardNumber] = useState(0);
  const [cardList, setCardList] = useState([]);

  const [loading, setLoading] = useState(t('common.loading'));

  useEffect(() => {
    let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
    if (xsrfToken) {
        xsrfToken = xsrfToken.split('=')[1]
    }
    let token = document.cookie.split('; ').find(row => row.startsWith('token'));
    if (token) {
        token = token.split('=')[1]
    }
    fetch(`${process.env.REACT_APP_API_URL}/api/package-master`, {
      method: 'GET',
      headers: {
        'X-XSRF-TOKEN': xsrfToken,
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json'
      },
      credentials: 'include'
    })
    .then(res => res.json())
    .then(data => {
      let list = [];
      if(!data.errors) {
        data.package_type_masters.forEach(item => {
          list[item.package_type] = item.package_type_name;
        });
        setPackageTypeList(list);
      } else {
        alert(Object.values(data.errors)[0]);
      }
    })
    .catch(err => {
      console.log(err);
    });

    fetch(`${process.env.REACT_APP_API_URL}/api/package/${id}`, {
      method: 'GET',
      headers: {
        'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
        'Bearer': decodeURIComponent(token),
        'Accept': 'application/json'
      },
      credentials: 'include',
    })
    .then(response => response.json())
    .then(data => {
      if(!data.errors) {
        setPackageInfo({
          packageId: data.package.id,
          packageType: data.package.type,
          packageName: data.package.name,
          packagePrice: data.package.price,
          packageNumber: data.package.number,
          packageStartAt: data.package.start_at.split(' ')[0],
          packageEndAt: data.package.end_at.split(' ')[0],
          packageImage: process.env.REACT_APP_ASSET_URL + data.package.image_url,
          packageImageEn: data.package.image_url_en ? process.env.REACT_APP_ASSET_URL + data.package.image_url_en : '',
          packageImageJp: data.package.image_url_jp ? process.env.REACT_APP_ASSET_URL + data.package.image_url_jp : '',
          packageStatus: data.package.status,
        });
        fetch(`${process.env.REACT_APP_API_URL}/api/package-cards/${data.package.id}`, {
          headers: {
            'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
            'Bearer': decodeURIComponent(token),
            'Accept': 'application/json'
          },
          credentials: 'include',
        })
        .then(response => response.json())
        .then(data => {
          if(!data.errors) {
            if (data.package_cards) {
              setCardNumber(data.package_cards.filter((card) => card.rank != 9).map((card) => card.number).reduce((a, b) => a + b, 0));
              setCardList(data.package_cards.map((card) => {
                return {
                  url: process.env.REACT_APP_ASSET_URL + card.image_url,
                  name: card.name,
                  rank: card.rank,
                  number: card.number,
                  stock: card.stock,
                  rewardPoint: card.point,
                  psa: card.psa,
                  isPsaEnabled: card.is_psa_enabled,
                  id: card.id,
                }
              }))
              setTotalRefundPoint(data.package_cards.map((card) => card.rank == 9 ? card.point : card.number * card.point).reduce((a, b) => a + b, 0));
              setTotalNumber(data.package_cards.filter((card) => card.rank != 9).map((card) => card.stock).reduce((a, b) => a + b, 0));
            }
          }
          setLoading(t('oripa.error'))
        })
      } else {
        alert(t('common.error'))
      }
    })
    .catch(error => {
      alert(t('common.error'))
    });
  }, []);

  const [modalImageIsOpen, setModalImageIsOpen] = useState([false, '']);

  const openImageModal = (e) => {
    setModalImageIsOpen([true, e.target.src]);
  }

  const closeImageModal = () => {
    setModalImageIsOpen([false, '']);
  }

  const CreateCardList = () => {
    if (cardList.length == 0) {
      return (
        <tr>
          <td colSpan="8">{loading}</td>
        </tr>
      );
    }
    return cardList.map((card) => {
      return <Tr oripa={card} openImageModal={openImageModal} cardNumber={cardNumber} confirmPackage={true} key={"card"+card.id} />
    })
  }

  const statusPrePublishChangeHandler = (e) => {
    let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
    if (xsrfToken) {
        xsrfToken = xsrfToken.split('=')[1]
    }
    let token = document.cookie.split('; ').find(row => row.startsWith('token'));
    if (token) {
        token = token.split('=')[1]
    }

    fetch(`${process.env.REACT_APP_API_URL}/api/status-pre-change/${packageInfo.packageId}`, {
      headers: {
        'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
        'Bearer': decodeURIComponent(token),
        'Accept': 'application/json'
      },
      credentials: 'include',
    })
    .then(response => response.json())
    .then(data => {
      if(!data.errors) {
        setPackageInfo({
          packageId: data.package.id,
          packageType: data.package.type,
          packageName: data.package.name,
          packagePrice: data.package.price,
          packageNumber: data.package.number,
          packageStartAt: data.package.start_at.split(' ')[0],
          packageEndAt: data.package.end_at.split(' ')[0],
          packageImage: process.env.REACT_APP_ASSET_URL + data.package.image_url,
          packageImageEn: data.package.image_url_en ? process.env.REACT_APP_ASSET_URL + data.package.image_url_en : '',
          packageImageJp: data.package.image_url_jp ? process.env.REACT_APP_ASSET_URL + data.package.image_url_jp : '',
          packageStatus: data.package.status,
        });
      } else {
        alert(Object.values(data.errors)[0]);
      }
    })
    .catch(error => {
      console.error(error);
    });
  }

  const statusChangeHandler = (e) => {
    if(packageInfo.packageStatus == 1 || packageInfo.packageStatus == 6) {
      if(!window.confirm(t('oripa.confirm3'))) {
        return;
      }
    }

    let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
    if (xsrfToken) {
        xsrfToken = xsrfToken.split('=')[1]
    }
    let token = document.cookie.split('; ').find(row => row.startsWith('token'));
    if (token) {
        token = token.split('=')[1]
    }

    fetch(`${process.env.REACT_APP_API_URL}/api/status-change/${packageInfo.packageId}`, {
      headers: {
        'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
        'Bearer': decodeURIComponent(token),
        'Accept': 'application/json'
      },
      credentials: 'include',
    })
    .then(response => response.json())
    .then(data => {
      if(!data.errors) {
        setPackageInfo({
          packageId: data.package.id,
          packageType: data.package.type,
          packageName: data.package.name,
          packagePrice: data.package.price,
          packageNumber: data.package.number,
          packageStartAt: data.package.start_at.split(' ')[0],
          packageEndAt: data.package.end_at.split(' ')[0],
          packageImage: process.env.REACT_APP_ASSET_URL + data.package.image_url,
          packageImageEn: data.package.image_url_en ? process.env.REACT_APP_ASSET_URL + data.package.image_url_en : '',
          packageImageJp: data.package.image_url_jp ? process.env.REACT_APP_ASSET_URL + data.package.image_url_jp : '',
          packageStatus: data.package.status,
        });
      } else {
        alert(Object.values(data.errors)[0]);
      }
    })
    .catch(error => {
      console.error(error);
    });
  }


  return (
    <>
      <Header />
      <SideMenu />
      <div className="oripa">
        <div className="oripa-content">
          <div className="oripa-title">{t('oripa.title')}</div>
          <div className='clearfix'></div>
          <div className="oripa-back">
            <Link to={`/${shop}/shop/stock`}>
              <button className="oripa-back-button">{t('oripa.back')}</button>
            </Link>
          </div>
          <div className="oripa-stop">
            {(packageInfo.packageStatus === 1 || packageInfo.packageStatus === 6 || packageInfo.packageStatus === 7) && <button className="oripa-stop-button" onClick={statusChangeHandler}>{t('oripa.start')}</button>}
            {packageInfo.packageStatus === 2 && <button className="oripa-stop-button" onClick={statusChangeHandler}>{t('oripa.stop')}</button>}
          </div>
          <div className="oripa-pre">
            {packageInfo.packageStatus === 1 && <button className="oripa-pre-button" onClick={statusPrePublishChangeHandler}>{t('oripa.release')}</button>}
            {packageInfo.packageStatus === 6 && <button className="oripa-pre-button" onClick={statusPrePublishChangeHandler}>{t('oripa.suspension')}</button>}
          </div>
          <div className="oripa-delete">
            {packageInfo.packageStatus != 2 && <button className="oripa-delete-button" onClick={deleteHandler}>{t('oripa.delete')}</button>}
          </div>
          <div className="oripa-edit">
            <Link to={`/${shop}/oripa/${id}/edit`}>
              <button className="oripa-edit-button">{t('oripa.edit')}</button>
            </Link>
            <button className="oripa-edit-button" onClick={copyHandler}>{t('oripa.copy')}</button>
          </div>
          <div className="oripa-edit">
            <a href={`/${shop}/oripa/${id}/preview`} target="_blank">
              <button className="oripa-edit-button">{t('oripa.preview')}</button>
            </a>
          </div>
          <div className='clearfix'></div>
          <dl className="oripa-info-confirm oripa-info-confirm-half">
            <dt className="oripa-info-confirm-title">{t('oripa.kind')}</dt>
            <dd className="oripa-info-confirm-text">{t('package_master.' + packageTypeList[packageInfo.packageType])}</dd>
            <dt className="oripa-info-confirm-title clear-left">{t('oripa.oripa_name')}</dt>
            <dd className="oripa-info-confirm-text">{packageInfo.packageName}</dd>
            <dt className="oripa-info-confirm-title clear-left">{t('oripa.price')}</dt>
            <dd className="oripa-info-confirm-text">{packageInfo.packagePrice} {t('oripa.yen')}</dd>
            <dt className="oripa-info-confirm-title clear-left">{t('oripa.setting')}</dt>
            <dd className="oripa-info-confirm-text">{} {totalNumber} / {packageInfo.packageNumber} {t('oripa.card')}</dd>
            <dt className="oripa-info-confirm-title clear-left">{t('oripa.period')}</dt>
            <dd className="oripa-info-confirm-text">{packageInfo.packageStartAt} 〜 {packageInfo.packageEndAt}</dd>
            <dt className="oripa-info-confirm-title clear-left">{t('oripa.total_points')}</dt>
            <dd className="oripa-info-confirm-text">{totalRefundPoint.toLocaleString()}pt</dd>
            <dt className="oripa-info-confirm-title clear-left">{t('oripa.status')}</dt>
            <dd className="oripa-info-confirm-text"><div className={`stock-status-${packageInfo.packageStatus}`}>{[t('oripa.preparation'), t('oripa.sale'), t('oripa.soldout'), t('oripa.ended'), "", t('oripa.release'), t('oripa.stopping')][packageInfo.packageStatus - 1]}</div></dd>

          </dl>
          <dl className="oripa-info-confirm">
            <dt className="oripa-info-confirm-title">{t('oripa.pop')}</dt>
              <dd className="oripa-info-confirm-text oripa-info-confirm-text-img">
                <img src={packageInfo.packageImage} alt={t('oripa.oripa_image')} className="oripa-info-confirm-image" />
            </dd>
            <dt className="oripa-info-confirm-title">{t('oripa.pop_en')}</dt>
              <dd className="oripa-info-confirm-text oripa-info-confirm-text-img">
                {packageInfo.packageImageEn && <img src={packageInfo.packageImageEn} alt={t('oripa.oripa_image')} className="oripa-info-confirm-image" />}
            </dd>
            <dt className="oripa-info-confirm-title">{t('oripa.pop_jp')}</dt>
              <dd className="oripa-info-confirm-text oripa-info-confirm-text-img">
                {packageInfo.packageImageJp && <img src={packageInfo.packageImageJp} alt={t('oripa.oripa_image')} className="oripa-info-confirm-image" />}
            </dd>
          </dl>
          <div className='clearfix'></div>
          <div className="oripa-info-sub-title">{t('oripa.card_setting')}</div>
            {!cardSetting ? 
              <>
                <button className="oripa-info-close-button" onClick={showCardSettingHandler}>{t('oripa.open')}</button>
                <div className='clearfix'></div>
                <div className='line2'></div>
              </>
              :
              <>
                <button className="oripa-info-close-button" onClick={hideCardSettingHandler}>{t('oripa.close')}</button>
                <div className='clearfix'></div>
                <div className='line2'></div>
                <div className="oripa-content-table">
                  <table className="oripa-content-table">
                    <thead>
                      <tr>
                        <th>{t('oripa.image')}</th>
                        <th>{t('oripa.name')}</th>
                        <th>{t('oripa.rank')}</th>
                        <th>{t('oripa.cards')}</th>
                        <th>{t('oripa.points')}</th>
                        <th>PSA</th>
                        <th>{t('oripa.probability')}</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <CreateCardList />
                    </tbody>
                  </table>
                </div>
              </>
            }
          </div>
        </div>
        {modalImageIsOpen[0] && 
        <ImageModal
          modalIsOpen={modalImageIsOpen}
          closeModal={closeImageModal}
          link={modalImageIsOpen[1]}
          customClass='oripa-info-card-image-modal'
        />
      }
    </>
  )
}

export default Oripa